module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag14_0655AT.e358c8a2.jpg";